import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    panel: {
      padding: 24,
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    }
  })
);

interface Props {
  approvers: any;
  groups: any;
  onWorkflowApproversChange: (approvers: string[]) => void;
}

function WorkflowPreApproversEditor(props: Props) {
  const { approvers, groups, onWorkflowApproversChange } = props;

  const classes = useStyles({});

  const onApproversChange = (event: React.ChangeEvent<{}>, value: any) => {
    onWorkflowApproversChange(value);
  };

  return (
    <div className={classes.panel}>
      <Autocomplete
        value={approvers}
        onChange={onApproversChange}
        multiple
        options={Object.keys(groups)}
        getOptionLabel={(option) => groups[option]}
        renderInput={(params) => <TextField {...params} label='Groups' placeholder='Select a group to add' InputLabelProps={{
          shrink: true
        }} />}
      />

    </div>);
};

export default WorkflowPreApproversEditor;
